import React from 'react';
import Icon from 'assets/Icon';
import styles from './style/listItem.module.css';

interface RadioItemProps {
  borderInset?: number,
  checked?: boolean,
  disabled?: boolean,
  handler?: Function,
  invert?: boolean,
  label?: string,
  name?: string,
  value?: string,
}

const RadioItem = ({
  borderInset,
  checked,
  disabled,
  handler,
  invert,
  label,
  name,
  value,
}:RadioItemProps) => (
  <button
    className={`
      ${styles.listItem}
      ${checked ? styles.listItem_checked : ''}
      ${invert ? styles.listItem_invert : ''}
    `}
    data-border-inset={borderInset}
    disabled={disabled}
    name={name}
    onClick={handler ? () => handler() : () => null}
    type="button"
    value={value}
  >
    { label }
    { checked ? (
      <Icon icon="RadioActive" fill="blueberry" />
    ) : (
      <Icon icon="RadioEmpty" fill={invert ? 'british-green-200' : 'warm-grey-100'} />
    )}
  </button>
);

RadioItem.defaultProps = {
  borderInset: 0,
  checked: false,
  disabled: false,
  handler: null,
  invert: false,
  label: 'Check Item',
  name: '',
  value: '',
};

export default RadioItem;
